import PageHeader from '../../components/layout/PageHeader';
import RepackWorkspace from '../../components/warehouse/repack/RepackWorkspace';
import { useRepackLabels } from '../../components/warehouse/repack/repackLabels';
import { useAuth } from '../../hooks/useAuth';

/**
 * /warehouse/repack — CONSOLE DE REPACK (Supervisor, desktop).
 *
 * Uma página, três operações do mesmo módulo: dividir (1 → N), juntar/
 * transferir (N → 1) e o picking fracionado (que NÃO gera pallet). O que as
 * une é o invariante do §3 — todo saldo continua vivo em exatamente um lugar —,
 * e é por isso que elas moram juntas: separá-las em três telas faria três
 * conferências de saldo diferentes.
 *
 * Permissão granular própria, como as outras páginas do módulo:
 * `wms:manage:repack` (expandida por `wms:manage`). Ela é também o que separa o
 * console do CHÃO: as rotas aceitam `wms:operate`, mas **criar pallet é ato do
 * Supervisor** (§6.2) e é esta permissão que o backend consulta para permitir
 * o LPN criado na hora.
 *
 * O REPACK DO CHÃO não está aqui: ele acontece no coletor, com o crachá e o
 * pallet de destino já etiquetado. Console redistribui e cria etiqueta; chão
 * executa o que já tem etiqueta.
 */
const WarehouseRepackPage = () => {
    const { label } = useRepackLabels();
    const { checkPermission } = useAuth();

    // A mesma permissão que o backend consulta para decidir `can_create_lpn`.
    // Lida aqui (e não presumida pela rota) para a tela e o servidor nunca
    // discordarem sobre quem pode criar pallet.
    const canCreateLpn = checkPermission('wms:manage:repack');

    return (
        <div className="space-y-6">
            <PageHeader title={label('wms.repack.title')} subtitle={label('wms.repack.subtitle')} />
            <RepackWorkspace label={label} canCreateLpn={canCreateLpn} />
        </div>
    );
};

export default WarehouseRepackPage;
